import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CommonAxiosGet } from "./CommonUtils/CommonAxios";
import { getfinancialyear } from "./CommonUtils/CommonGetApis";
import CategoryChart from "./CategoryChart";
import BlockWiseExpenditureDashBoard from "./Dashboard/BlockWiseExpenditureDashBoard";



/* ─────────────────────────── THEME ─────────────────────────── */
const C = {
  forest: "#2d5853",
  forestDark: "#1e3d39",
  forestLight: "#3a6e68",
  mint: "#48b17e",
  ember: "#d9702b",
  crimson: "#692520",
  crimsonDk: "#8b3028",
  emberDk: "#b8521a",
  mintDk: "#000000",
  bg: "#f0f4f3",
};

const TABS = [
  { label: "Overall", icon: "⊞" },
  { label: "Taxes", icon: "🧾" },
  { label: "Non-Taxes", icon: "🏦" },
  { label: "Miscellaneous", icon: "📂" },
];

/* ───────────── HELPERS ───────────── */
function pctColor(p) {
  if (p >= 25) return "good";
  if (p >= 10) return "avg";
  return "low";
}


const getUnitLabel = (roleId) => {
  if (roleId === 4 || roleId === 2) return "(Cr)";
  if (roleId === 5 || roleId === 7) return "(Lakhs)";
  if (roleId === 1) return "(Rs)";
  return "";
};

/* ───────────── POPUP ───────────── */
function PanchayatPopup({ tab, data, onClose }) {
  /*  const rows = PANCHAYAT_DATA[tab] ?? []; */



  const rawRoleId = useSelector(
    (state) => state.reducers?.commonmastersreducer?.dualroles
  );

  const roleId = Number(rawRoleId);

  const getLevelLabel = () => {
    if (roleId === 4 || roleId === 2) return "District";
    if (roleId === 5) return "Revenue Division";
    if (roleId === 7) return "Mandal";
    if (roleId === 1) return "Panchayat";
    return "";
  };

  const rows = (data || []).map((d) => ({
    name:
      d.district_desc ||
      d.revenue_division_name ||
      d.mandal_desc ||
      d.secretariat_desc,

    demand: d.total_demand,
    collection: d.total_collected,
    balance: d.total_balance,

    //Rebate
    rebate: d.total_rebate,

    pct: d.total_demand
      ? Math.floor((d.total_collected / d.total_demand) * 10000) / 100
      : 0,
  }));
  const [search, setSearch] = useState("");
  const filtered = rows.filter(r =>
    r.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div onClick={onClose} className="rd-overlay" onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        onClose();
      }
    }}
      role="button"
      tabIndex={0}>
      <div onClick={e => e.stopPropagation()} className="rd-popup" role="presentation">

        {/* HEADER */}
        <div className="rd-popup-header">
          <div className="rd-popup-icon">🏘️</div>

          <div className="rd-popup-title-wrap">
            <div className="rd-popup-sub">{tab} Revenue</div>
            <div className="rd-popup-title">
              {getLevelLabel()}-Wise Revenue Status {getUnitLabel(roleId)}
            </div>
          </div>

          <button
            onClick={onClose}
            className="rd-close"
          >✕</button>
        </div>

        {/* SEARCH */}
        <div className="rd-search-wrap">
          <div className="rd-search-box">
            <span className="rd-search-icon">🔍</span>

            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder={`Search ${getLevelLabel().toLowerCase()}...`}
              className="rd-search-input"
            />
          </div>
        </div>

        {/* STATS */}
        <div className="rd-stats">
          {[
            { label: `Total ${getLevelLabel()}s`, val: rows.length },
            { label: "Shown", val: filtered.length },
            {
              label: "Avg. Collection",
              val: rows.length
                ? (rows.reduce((s, r) => s + r.pct, 0) / rows.length).toFixed(2) + "%"
                : "—"
            }
          ].map((s, i) => (
            <div key={i} className="rd-stat">
              <div className="rd-stat-value">{s.val}</div>
              <div className="rd-stat-label">{s.label}</div>
            </div>
          ))}
        </div>

        {/* LIST */}
        <div className="rd-list">
          {filtered.length === 0 && (
            <div className="rd-empty">
              {`No ${getLevelLabel()}s found.`}
            </div>
          )}

          {filtered.map((row, i) => {
            const col = pctColor(row.pct);
            const barW = Math.min(row.pct, 100);

            return (
              <div
                key={row.name}
                className="rd-item"
                style={{ animationDelay: `${i * 0.06}s` }}
              >
                {/* HEADER */}
                <div className="rd-item-head">
                  <div className="rd-item-left">
                    <div className="rd-item-icon">🏛️</div>
                    <span className="rd-item-name">{row.name}</span>
                  </div>

                  <span
                    className="rd-badge"
                    style={{
                      background: col.bg,
                      color: col.text
                    }}
                  >
                    {row.pct}%
                  </span>
                </div>

                {/* BODY */}
                <div className="rd-item-body">

                  {/* PROGRESS */}
                  <div className="rd-progress">
                    <div
                      className="rd-progress-fill"
                      style={{
                        width: `${barW}%`,
                        background:
                          row.pct >= 25
                            ? "#48b17e"
                            : row.pct >= 10
                              ? "#d9702b"
                              : "#692520"
                      }}
                    />
                  </div>

                  {/* GRID */}
                  <div className="rd-grid1">
                    {[
                      { label: "Demand", val: row.demand, icon: "📈", color: "#692520" },
                      { label: "Collection", val: row.collection, icon: "💰", color: "#1e6b4a" },

                      //Rebate
                      ...((tab === "Overall" || tab === "Taxes")
                        ? [{
                          label: "Rebate",
                          val: row.rebate,
                          icon: "🎁",
                          color: "#4b6b6f"
                        }]
                        : []),
                      { label: "Balance", val: row.balance, icon: "👛", color: "#d9702b" },

                    ].map(f => (
                      <div key={f.label} className="rd-box">
                        <div className="rd-box-label">
                          {f.icon} {f.label}
                        </div>
                        <div
                          className="rd-box-value"
                          style={{ color: f.color }}
                        >
                          {formatAmount(f.val, roleId)}
                        </div>
                      </div>
                    ))}
                  </div>

                </div>
              </div>
            );
          })}
        </div>

        {/* FOOTER */}
        <div className="rd-footer">
          <span className="rd-footer-text">
            Showing {filtered.length} of {rows.length} {getLevelLabel()}s
          </span>

          <button
            onClick={onClose}
            className="rd-footer-btn"
          >
            ✕ Close
          </button>
        </div>

      </div>
    </div>
  );
}
/* ───────────── CARD ───────────── */
function StatCard({ card }) {
  return (
    <div className="rd-card" style={{ background: card.gradient }}>
      <div className="rd-card-icon">{card.icon}</div>
      <div className="rd-card-label">{card.label}</div>
      <div className="rd-card-amount">
        {card.amount}
        {card.pct && <span className="rd-card-pct">{card.pct}</span>}
      </div>

      <div className="rd-bar">
        <div className="rd-bar-fill" style={{ width: `${card.barPct}%` }}></div>
      </div>

      <div className="rd-extra">
        <span>→ Current</span>
        <b>{card.current}</b>
      </div>

      {/* --------Rebate----*/}
      {card.arrear !== undefined && (
        <div className="rd-extra">
          <span>⏱ Arrear</span>
          <b>{card.arrear}</b>
        </div>
      )}
    </div>
  );
}

/* ───────────── TAB ───────────── */
function TabBtn({ tab, active, onClick }) {
  return (
    <button
      className={`rd-tab-btn ${active ? "active" : ""}`}
      onClick={onClick}
    >
      <span>{tab.icon}</span> {tab.label}
    </button>
  );
}


const formatAmount = (val, roleId) => {
  if (val === null || val === undefined) return "0";

  if (roleId === 1) {
    return val.toLocaleString("en-IN");
  }

  let converted;


  if (roleId === 4 || roleId === 2) {
    converted = val / 10000000;
  } else if (roleId === 5 || roleId === 7) {
    converted = val / 100000;
  } else {
    return val;
  }

  const truncated = Math.floor(converted * 100) / 100;
  return truncated.toFixed(2);
};

/* ───────────── MAIN ───────────── */
export default function RevenueDashboard() {

  const [activeTab, setActiveTab] = useState("Overall");
  const [showPopup, setShowPopup] = useState(false);

  const financialyear_gen = useSelector(
    (state) => state.reducers?.commonmastersreducer?.financialyear
  );

  const [financialYear, setFinancialYear] = useState("");


  const rawRoleId = useSelector(
    (state) => state.reducers?.commonmastersreducer?.dualroles
  );

  const roleId = Number(rawRoleId);

  const [allSummaryData, setAllSummaryData] = useState({});
  const [allPanchayatData, setAllPanchayatData] = useState({});

  const summaryData = allSummaryData[activeTab] || {};
  const panchayatData = allPanchayatData[activeTab] || [];


  const getSummaryScode = (res) => res?.data?.scode === "01" ? res.data.data?.[0] || {} : {};

  const getIndividualListScode = (res) => res?.data?.scode === "01" ? res.data.data || [] : [];

  useEffect(() => {
    getfinancialyear();
  }, []);

  useEffect(() => {
    if (financialyear_gen?.length > 0 && !financialYear) {
      setFinancialYear(financialyear_gen[0].acdyr);
    }
  }, [financialyear_gen]);


  useEffect(() => {
    if (!roleId || !financialYear) return;

    const fetchAllData = async () => {
      try {
        const [
          overallRes,
          taxRes,
          nonTaxRes,
          miscRes,
          overallIndRes,
          taxIndRes,
          nonTaxIndRes,
          miscIndRes,
        ] = await Promise.all([
          CommonAxiosGet(`overall/${roleId}/${financialYear}`),
          CommonAxiosGet(`category/${roleId}/${financialYear}/House Tax`),
          CommonAxiosGet(`category/${roleId}/${financialYear}/Trade License Fee,Tap Fee,Cell Tower Fee,Lease Fee`),
          CommonAxiosGet(`category/${roleId}/${financialYear}/Miscellaneous`),

          CommonAxiosGet(`individual/${roleId}/${financialYear}/ALL`),
          CommonAxiosGet(`individual/${roleId}/${financialYear}/House Tax`),
          CommonAxiosGet(`individual/${roleId}/${financialYear}/Trade License Fee,Tap Fee,Cell Tower Fee,Lease Fee`),
          CommonAxiosGet(`individual/${roleId}/${financialYear}/Miscellaneous`)
        ]);

        setAllSummaryData({
          Overall: getSummaryScode(overallRes),
          Taxes: getSummaryScode(taxRes),
          "Non-Taxes": getSummaryScode(nonTaxRes),
          Miscellaneous: getSummaryScode(miscRes),
        });

        setAllPanchayatData({
          Overall: getIndividualListScode(overallIndRes),
          Taxes: getIndividualListScode(taxIndRes),
          "Non-Taxes": getIndividualListScode(nonTaxIndRes),
          Miscellaneous: getIndividualListScode(miscIndRes),
        });

      } catch (err) {

      }
    };

    fetchAllData();
  }, [roleId, financialYear]);


  const ICON_MAP = {
    Overall: { demand: "📈", collection: "💰", balance: "👛" },
    Taxes: { demand: "🧾", collection: "💰", balance: "👛" },
    "Non-Taxes": { demand: "🏦", collection: "💰", balance: "👛" },
    Miscellaneous: { demand: "📂", collection: "💰", balance: "👛" },
  };

  const icons = ICON_MAP[activeTab] || ICON_MAP["Overall"];

  const getPercentage = (value) => {
    if (!summaryData.total_demand || summaryData.total_demand === 0) return 0;
    const percent = (value / summaryData.total_demand) * 100;
    return Math.floor(percent * 100) / 100;
  };


  const getLevelLabel = () => {
    if (roleId === 4 || roleId === 2) return "District";
    if (roleId === 5) return "Revenue Division";
    if (roleId === 7) return "Mandal";
    if (roleId === 1) return "Panchayat";
    return "";
  };

  const cards = [
    {
      key: "demand",
      label: `Total Demand  ${getUnitLabel(roleId)}`,
      icon: icons.demand,
      amount: formatAmount(summaryData.total_demand, roleId),
      pct: null,
      barPct: 100,
      gradient: `linear-gradient(140deg,#692520,#8b3028)`,
      current: formatAmount(summaryData.current_demand, roleId),
      arrear: formatAmount(summaryData.arrear_demand, roleId),
    },
    {
      key: "collection",
      label: `Total Collection  ${getUnitLabel(roleId)}`,
      icon: icons.collection,
      amount: formatAmount(summaryData.total_collected, roleId),
      pct: getPercentage(summaryData.total_collected) + "%",
      barPct: getPercentage(summaryData.total_collected) || 0,
      gradient: `linear-gradient(140deg,#1e6b4a,#48b17e)`,
      current: formatAmount(summaryData.current_collected, roleId),
      arrear: formatAmount(summaryData.arrear_collected, roleId),
    },

    // REBATE CARD
    ...((activeTab === "Overall" || activeTab === "Taxes")
      ? [{
        key: "rebate",
        label: `Total Rebate ${getUnitLabel(roleId)}`,
        icon: "🎁",
        amount: formatAmount(summaryData.total_rebate, roleId),
        pct: getPercentage(summaryData.total_rebate) + "%",
        barPct: getPercentage(summaryData.total_rebate) || 0,
        gradient: `linear-gradient(140deg,#5b7c99,#7fa1c3)`,
        current: formatAmount(summaryData.current_rebate, roleId),
      }]
      : []),

    {
      key: "balance",
      label: `Total Balance  ${getUnitLabel(roleId)}`,
      icon: icons.balance,
      amount: formatAmount(summaryData.total_balance, roleId),
      pct: getPercentage(summaryData.total_balance) + "%",
      barPct: getPercentage(summaryData.total_balance) || 0,
      gradient: `linear-gradient(140deg,#b8521a,#d9702b)`,
      current: formatAmount(summaryData.current_balance, roleId),
      arrear: formatAmount(summaryData.arrear_balance, roleId),
    },


  ];


  const categoryChartData = () => {
    const fullData = [
      {
        name: "Taxes",
        demand: allSummaryData?.Taxes?.total_demand || 0,
        collection: allSummaryData?.Taxes?.total_collected || 0,
        rebate: allSummaryData?.Taxes?.total_rebate || 0,
        balance: allSummaryData?.Taxes?.total_balance || 0,
      },
      {
        name: "Non-Taxes",
        demand: allSummaryData?.["Non-Taxes"]?.total_demand || 0,
        collection: allSummaryData?.["Non-Taxes"]?.total_collected || 0,
        rebate: 0,
        balance: allSummaryData?.["Non-Taxes"]?.total_balance || 0,
      },
      {
        name: "Miscellaneous",
        demand: allSummaryData?.Miscellaneous?.total_demand || 0,
        collection: allSummaryData?.Miscellaneous?.total_collected || 0,
        rebate: 0,
        balance: allSummaryData?.Miscellaneous?.total_balance || 0,
      }
    ];

    if (activeTab === "Overall") return fullData;

    const selected = fullData.find(item => item.name === activeTab);

    console.log("Selected Data:", selected);
    if (!selected) return [];

    return [
      { name: "Demand", value: selected.demand },
      { name: "Collection", value: selected.collection },
      ...(activeTab === "Taxes"
        ? [{ name: "Rebate", value: selected.rebate }]
        : []),

      { name: "Balance", value: selected.balance },
    ];
  };


  const [dashboardType, setDashboardType] = useState("revenue");
  return (
    <>
      {/* <div className="rd-header">
        <div className="rd-header-icon">📊</div>
        <h2 className="rd-title">Revenue Status</h2>
      </div> */}
      {/* <div
        className="rd-header"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 200,
        }}
      >
        <div className="rd-header-icon">📊</div>
        <h2 className="rd-title">Revenue Status</h2>
      </div> */}


      
<div
  className="rd-header"
  style={{
    position: "sticky",
    top: 0,
    zIndex: 200,
    display: "flex",
    alignItems: "center",
  }}
>
   <button
  type="button"
  onClick={() => setDashboardType("revenue")}
  style={{ background: "none", border: "none", cursor: "pointer" }}
>
  <h2>📊</h2>
</button>

  <h2
  className="rd-title"
  role="button"
  tabIndex={0}
  style={{
    cursor: "pointer",
    marginRight: "12px",
    color: dashboardType === "revenue" ? "#ffd54f" : "#ffffff",
    fontWeight: dashboardType === "revenue" ? "700" : "500",
    borderBottom:
      dashboardType === "revenue"
        ? "3px solid #ffd54f"
        : "3px solid transparent",
    transition: "all 0.3s ease",
  }}
  onClick={() => setDashboardType("revenue")}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setDashboardType("revenue");
    }
  }}
>
  Revenue Status
</h2>

    <>
      <span
        style={{
          color: "#ffffff",
          fontSize: "22px",
          fontWeight: "bold",
          margin: "0 12px",
        }}
      >
        |
      </span>

       <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <h2
  role="button"
  tabIndex={0}
  style={{ cursor: "pointer", margin: 0 }}
  onClick={() => setDashboardType("expenditure")}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setDashboardType("expenditure");
    }
  }}
>
  💸
</h2>

              <h2
  className="rd-title"
  role="button"
  tabIndex={0}
  style={{
    margin: 0,
    cursor: "pointer",
    color: dashboardType === "expenditure" ? "#ffd54f" : "#ffffff",
    fontWeight: dashboardType === "expenditure" ? "700" : "500",
    borderBottom:
      dashboardType === "expenditure"
        ? "3px solid #ffd54f"
        : "3px solid transparent",
    transition: "all 0.3s ease",
  }}
  onClick={() => setDashboardType("expenditure")}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setDashboardType("expenditure");
    }
  }}
>
  Expenditure Status
</h2>
            </div>
    </>
</div>

{dashboardType === "revenue" ? (<>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          margin: "10px 0 15px 30px"
        }}
      >
        <label
          style={{
            fontWeight: "600",
            color: "#2d5853"
          }}
        >
          Select Financial Year:
        </label>
        <select
          value={financialYear || ""}
          onChange={(e) => {
            setFinancialYear(e.target.value);
            setActiveTab("Overall");
          }}
          style={{
            padding: "6px 10px",
            borderRadius: "6px",
            border: "1px solid #2d5853",
            outline: "none",
            boxShadow: "0 0 4px rgba(45,88,83,0.4)"
          }}
        >
          {financialyear_gen?.map((data, i) => (
            <option value={data.acdyr} key={i}>
              {data.acdyr}
            </option>
          ))}
        </select>
      </div>

      <div className="rd-body">

        <div className="rd-tabs">
          {TABS.map((t) => (
            <TabBtn
              key={t.label}
              tab={t}
              active={activeTab === t.label}
              onClick={() => setActiveTab(t.label)}
            />
          ))}
        </div>

        <div className="rd-label">
          {activeTab} — Revenue Summary
        </div>

        <div className="rd-grid">
          {cards.map((c) => (
            <StatCard key={c.key} card={c} />
          ))}
        </div>

        {panchayatData.length > 1 && (
          <div className="rd-center">
            <button
              className="rd-btn"
              onClick={() => setShowPopup(true)}
            >
              🏘️ View {activeTab} – {getLevelLabel()} Wise Revenue Status →
            </button>
          </div>
        )}


      </div>
      <div className="rd-body">
        <CategoryChart data={categoryChartData()} roleId={roleId} activeTab={activeTab} />
      </div>


      {showPopup && (
        <PanchayatPopup
          tab={activeTab}
          data={panchayatData}
          onClose={() => setShowPopup(false)}
        />
      )}
    </>
  ) : (
  <BlockWiseExpenditureDashBoard />
)}
    </>
  );
}